var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.88889C0 4.52572 0.196892 4.1911 0.514357 4.01473L7.51436 0.125843C7.81638 -0.0419476 8.18362 -0.0419476 8.48564 0.125843L15.4856 4.01473C15.8031 4.1911 16 4.52572 16 4.88889V9.52757C16 13.1592 14.0311 16.5054 10.8564 18.2691L8.48564 19.5862C8.18362 19.754 7.81638 19.754 7.51436 19.5862L5.14357 18.2691C1.96892 16.5054 0 13.1592 0 9.52757V4.88889ZM10.773 7.32571C11.0659 7.6186 11.0659 8.09348 10.773 8.38637L9.18196 9.97738L10.773 11.5684C11.0659 11.8613 11.0659 12.3362 10.773 12.629C10.4801 12.9219 10.0052 12.9219 9.71231 12.629L8.1213 11.038L6.53033 12.629C6.23744 12.9219 5.76256 12.9219 5.46967 12.629C5.17678 12.3361 5.17678 11.8612 5.46967 11.5684L7.06064 9.97738L5.46967 8.38641C5.17678 8.09351 5.17678 7.61864 5.46967 7.32575C5.76256 7.03285 6.23744 7.03285 6.53033 7.32575L8.1213 8.91672L9.71231 7.32571C10.0052 7.03282 10.4801 7.03282 10.773 7.32571Z",
    fill: "#F4C8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldClose);
export default __webpack_public_path__ + "static/media/ShieldClose.3c4c272010c018538f0931f6bd25f9ec.svg";
export { ForwardRef as ReactComponent };